import React from 'react';
import {connect} from 'react-redux';
import { Routes, Route } from 'react-router-dom';
import { AdmsRepository } from '../../redux/AdmsActions';
import {EMDHistoryListView, EMDHistoryCardView} from '../../views/containers'
import {LoadingComponent} from '../../utils/ui'
import {PromiseSequenceRunner} from '../../utils/promiseUtil'
import { factory } from '../../components/adms/Providers'
import withRouter from '../../withRouter';

/* Панель истории версий (список активов) и содержимого ЕМД.
* Устанавливает дополнительный фильтр на отбор только версий ЕМД
* Отображает: 
* 1. панель с временной лининей и со списком ЕМД.
* 2. карточка ЕМД и отображение содеримого.
*/ 
class EMDHistoryPanel extends React.Component {
  
    state = {
      loading: false,
      error: undefined,
    }
  
    componentWillMount() {
        this.loadAdms()
    }
    // componentDidMount() {
    //     this.loadAdms()
    // }

    loadAdms() {
      this.setState({loading: true})
      return PromiseSequenceRunner([
        //Загрузить таксономию каталога, так как в карточках потображаются классификационный признаки
        this.props.dispatch(AdmsRepository.loadThemeTaxonomy()),
        //Установить обязательный фильтр
        //Задание rfilter можно подсмотреть в логе connect.js onRefreshList(actions, conditions) AssetListView
        this.props.dispatch(AdmsRepository.SET_RFILTER([{alias: "theme", label: "Единая модель данных ГИС ХББ", operator: "=", predicate: "http://www.w3.org/ns/dcat#theme", type: "uri", value: "http://hbz.ru/skos/EMD"}]))
      ])
      .then ((response) =>{
        this.setState({loading: false, error: undefined});
      })
      .catch(e => { 
        this.setState({loading: false, error: e});
      });
    }
    
  
    onLoadMore = () => {
    }
  
    render() {
      console.log(this);
      const { loading } = this.state
      return (
        (loading? 
          <LoadingComponent />:
          <Routes>
            <Route path="/emd/:id" element={<EMDHistoryCardView factory={factory} />}></Route>            
            <Route path="*" element={<EMDHistoryListView factory={factory} />}></Route>
          </Routes>
        )
      );
    }
  }
  
function mapStateToProps(state, props) {
  const { vset } = state;
  const { graph, lang } = props;
  return {
    graph: (graph)?graph: vset.graph,
    lang: (lang)?lang: vset.lang,
  }
};


export default withRouter(connect(mapStateToProps)(EMDHistoryPanel))
